export { ArticleMiniature } from './ArticleMiniature';
